"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calestano": {
    "ed804aad": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "skipSearch": false
    }],
    "aplicella": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1bf4fd8b": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "skipSearch": false
    }],
    "giarale": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d906ae68": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "skipSearch": false
    }],
    "iano": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08883f61": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "skipSearch": false
    }],
    "tavolana": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bbb153c6": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "skipSearch": false
    }],
    "torre-di-marzolara": [{
      "hkey": "c4d12565",
      "slug": "calestano",
      "name": "Calestano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d95f591": [{
      "hkey": "11669793",
      "slug": "vallerano",
      "name": "Vallerano",
      "primary": true,
      "skipSearch": false
    }],
    "valleranno": [{
      "hkey": "11669793",
      "slug": "vallerano",
      "name": "Vallerano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;